export const GeneralSettingsConstants = {
    POSTMASTER: 'postmaster@desk.msging.net',
    //Time Unity
    DAY_IN_SECONDS: 86400,
    HOUR_IN_SECONDS: 3600,
    MINUTE_IN_SECONDS: 60,
    LIMIT_MINUTE: 43200,
    LIMIT_HOUR: 720,
    //Automatic Distribution Settings
    AGENT_SLOTS_ENABLED: 'AgentSlotsEnabled',
    AGENT_SLOTS: 'AgentSlots',
    //Verify Attendants Available on Queue Settings
    REDIRECT_WHEN_NO_AGENTS_ON_QUEUE: 'RedirectWhenNoAgentsOnQueue',
    //Emoji Settings
    CAN_SEND_EMOJI: 'CanSendEmojis',
    //Attachment Settings
    CAN_SEND_ATTACHMENT: 'CanSendAttachment',
    BLOCK_EXTERNAL_ATTACHMENT: 'BlockExternalAttachment',
    //Audio Recording Settings
    CAN_SEND_AUDIO_RECORDING: 'CanSendAudioRecording',
    //Active Messages Settings
    ACTIVE_MESSAGE_ENABLED: 'ActiveMessageEnabled',
    ACTIVE_MESSAGE_SETTINGS_PROGRESS: 'ActiveMessageSettingsInProgress',
    ACTIVE_MESSAGE_CONFIGURATION_CONTACT_FIELDS: 'ActiveMessageContactFieldsSearch',
    ACTIVE_MESSAGE_CONFIGURATION_SEARCH_SOURCE: 'ActiveMessageSearchSource',
    ACTIVE_MESSAGE_CONFIGURATION_ROUTER_IDENTITY: 'RouterIdentityActiveCampaign',
    //Agent Response Delay Settings
    AGENT_RESPONSE_DELAY_ENABLED: 'AgentResponseDelayEnabled',
    AGENT_MAX_RESPONSE_DELAY: 'AgentMaxResponseDelay',
    //Customer Response Delay Settings
    CUSTOMER_RESPONSE_DELAY_ENABLED: 'CustomerResponseDelayEnabled',
    CUSTOMER_MAX_RESPONSE_DELAY: 'CustomerMaxResponseDelay',
    CUSTOMER_WARNING_RESPONSE_DELAY: 'CustomerWarningResponseDelay',
    IGNORE_CREATE_TICKET_ON_USER_MESSAGE: 'IgnoreCreateTicketOnUserMessage',
    //Automatic Closing Tickets Settings
    AUTOMATIC_CLOSED_TICKET_ALLOWED: 'AutomaticClosedTicketIsAllowed',
    AUTOMATIC_CLOSED_TICKET_ENABLED: 'AutomaticClosedTicketIsEnabled',
    MAX_CLIENT_MINUTES_DOWNTIME: 'MaxClientMinutesDowntime',
    EXPECT_INTERACTION_AGENT: 'ExpectInteractionAgent',
    USE_INACTIVITY_TAGS: 'UseInactivityTags',
    INACTIVITY_TAGS: 'InactivityTags',
    REMOVE_TICKET_CLOSED_ATTENDANCE: 'SetTicketClosedByClientAsClosed',
    USE_MESSAGE_BEFORE_AUTO_CLOSED_TICKET: 'UseInactivityMessage',
    MESSAGE_BEFORE_AUTO_CLOSED_TICKET: 'InactivityMessage',
    MESSAGE_BEFORE_AUTO_CLOSED_TICKET_DOWNTIME: 'InactivityMessageDowntime',
    WAITING_TICKETS_COUNT_HIDDENNESS: 'WaitingTicketsCountHiddenness',
    ITEMS_PER_PAGE_DESK_MONITORING: 'ItemsPerPageDeskMonitoring',
    RESET_CLIENT_INACTIVITY_TIMER_ON_AGENT_INTERACTION: 'ResetClientInactivityTimerOnAgentInteraction',
    RESET_CLIENT_INACTIVITY_TIMER_ON_FIRST_AGENT_INTERACTION: 'ResetClientInactivityTimerOnFirstAgentInteraction',
    //Desk Box Settings
    CLOSE_TICKET_ON_LEAVING_FROM_DESK_SETTING: 'CloseTicketOnLeavingFromDeskSetting',
    TENANT_BOT_BLIP_COPILOT_ENABLED: 'TenantBotBlipCopilotEnabled',
    CARE_COPILOT_ENABLED: 'CareCopilotEnabled',
    //Satisfaction Survey Dashboard
    ATTENDANCE_SATISFACTION_SURVEY_ENABLED: 'AttendanceSatisfactionSurveyEnabled',
};
export const GeneralSettingsTracks = {
    GENERAL_SETTING_TICKET_NUMBER: 'helpdesk-general-settings-ticket-number',
    GENERAL_SETTING_ATTENDANTS_AVAILABLE_QUEUE_ENABLED: 'helpdesk-general-settings-attendants-available-per-queue-enabled',
    GENERAL_SETTING_ATTENDANTS_AVAILABLE_QUEUE_DISABLED: 'helpdesk-general-settings-attendants-available-per-queue-desabled',
    GENERAL_SETTING_OPENED: 'helpdesk-general-settings-opened',
    GENERAL_SETTINGS_TICKET_CLOSURE_CHANGE_ATTENDANT_START: 'helpdesk-general-settings-ticket-closure-change-attendant-start',
    GENERAL_SETTINGS_TICKET_CLOSURE_CHANGE_CUSTOMER_START: 'helpdesk-general-settings-ticket-closure-change-customer-start',
    GENERAL_SETTINGS_TICKET_CLOSURE_CHANGES_SAVED: 'helpdesk-general-settings-ticket-closure-changes-saved',
};
